import React from 'react';
import PropTypes from 'prop-types';
import {InputLabel} from '@material-ui/core';

import Button from '../formElements/Button';
import sAction from 'sAction';

export default function ViewSelect({views}) {
    return (
        <React.Fragment>
            {views.map((view, index) => (
                <a href={view.link} key={index}>
                    <InputLabel shrink={true}>{sAction.translate(view.title)}</InputLabel>
                    <Button type="button" className="acmButton">
                        <div className={`buttonIcon icon-${view.icon}`}/>
                    </Button>
                </a>
            ))}
        </React.Fragment>
    );
}

ViewSelect.propTypes = {
    views: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string.isRequired,
            icon: PropTypes.string.isRequired,
            title: PropTypes.string,
        }),
    ).isRequired,
};
